//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
// logout-btn imports
import { IProps, IContainer } from "./LogoutBtn.d";
import { A } from "@ui";
// util
import { logger } from "@util/logger.util";
import { doUserLogout } from "@util/auth.util";
import { logoutUser } from "@mutations";
import { snackBarOpen } from "@actions/snack-bar.actions";
import { track, TrackingEvents } from "@util/analytics.util";

// material-ui
import { Button, ListItemIcon, ListItemText, MenuItem } from "@material-ui/core";
import { CWIDProps } from "@clockwise/web-commons/src/util/cw-id.util";

//////////////////
// COMPONENT
//////////////////
class LogoutBtnCmpt extends React.Component<IProps & CWIDProps> {
  private logout() {
    const { environment } = this.props.relay;
    track(TrackingEvents.AUTH.BEGIN_LOGOUT);
    logoutUser({
      environment,
      input: {},
      onSuccess: (res) => this.onLogout(res),
      onError: (error?: any) => logger.error("An error occurred on logout", error),
    });
  }

  private onLogout(_response: any) {
    doUserLogout();
    if (this.props.onLogout) {
      this.props.onLogout();
    }
  }

  public render() {
    const btnProps = {
      primary: this.props.primary,
      onClick: this.logout.bind(this),
    };

    if (this.props.anchor) {
      return (
        <A cw-id={this.props["cw-id"]} onClick={() => this.logout()}>
          Sign out
        </A>
      );
    } else if (this.props.flat) {
      return (
        <Button cw-id={this.props["cw-id"]} {...btnProps}>
          <span>Sign out</span>
        </Button>
      );
    } else if (this.props.isNewMenuItem || this.props.isMenuItem) {
      return (
        <MenuItem cw-id={this.props["cw-id"]} onClick={btnProps.onClick}>
          {this.props.menuItemIcon ? <ListItemIcon>{this.props.menuItemIcon}</ListItemIcon> : ""}
          <ListItemText inset primary="Sign out" />
        </MenuItem>
      );
    } else {
      return (
        <Button cw-id={this.props["cw-id"]} {...btnProps}>
          <span>Sign out</span>
        </Button>
      );
    }
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(state: any, _ownProps: IContainer) {
  return {
    isChromeExtension: state.webExtension.isWebExtension,
  };
}

const LogoutBtn_redux = connect(mapStateToProps, {
  snackBarOpen,
})(LogoutBtnCmpt);

//////////////////
// RELAY
//////////////////
export const LogoutBtn = createFragmentContainer<IContainer>(LogoutBtn_redux, {});
